<template>
    <v-layout align-center justify-center class="fill-height">
        <v-flex xs12 sm8 md4>
            <v-img v-if="$vuetify.theme.dark" src="../assets/fps.png" height="300" contain />
            <!-- <v-img src="/images/logo_black.png" height="300" contain /> -->
            <v-img v-else src="../assets/fps.png" height="300" contain />
            <div class="text-center">
                <span class="overline text-center">BeeTasking — v3.0.0</span>
            </div>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapState } from 'vuex'
export default {
	computed: {
		...mapState({
			authentication: state => state.auth.authentication
		})
	},
	created () {
		// console.log (this.authentication)// console.log()
	}
}
</script>
